import { render, staticRenderFns } from "./ArtistDetails.vue?vue&type=template&id=65b9dc94&scoped=true"
import script from "./ArtistDetails.vue?vue&type=script&lang=js"
export * from "./ArtistDetails.vue?vue&type=script&lang=js"
import style0 from "./ArtistDetails.vue?vue&type=style&index=0&id=65b9dc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9dc94",
  null
  
)

export default component.exports